module.exports = __webpack_public_path__ + "static/media/martina-rua.87defdc0.png";